import httpClient from './httpClient'

const END_POINT = '/api/personas'

const getByToken = (token) => httpClient.get(END_POINT, { params: { token: token } })

const getByEmail = (email) => httpClient.get(END_POINT, { params: { email: email } })

const getById = (id) => httpClient.get(END_POINT, { params: { id: id } })

const forgottenPassword = (email,locale) => httpClient.post(`${END_POINT}/recovery-password`, { email: email, language: locale })

const updatePassword = (token, password) => httpClient.put(`${END_POINT}/set-password`, { token: token, plainPassword: password })

export {

    getByToken,
    getByEmail,
    getById,
    forgottenPassword,
    updatePassword

}